const ListItemIcon = () => {
    return {
        MuiListItemIcon: {
            styleOverrides : {
                root: {
                }
            }
        }
    };
}

export default ListItemIcon;